import { defineStore } from 'pinia'
import { useAuthStore } from '@/stores/auth'
import { useUserStore } from '@/stores/user'

export const useFooterStore = defineStore('footer', {
  state: () => ({
    baseApp: {},
    services: {},
    customerSupport: {},
    policy: {},
    socialNetworks: [],
    visibilityByUserType: {},
    copyright: 'ACE & KBA',
    defaultSectionOrder: ['baseApp', 'services', 'policy', 'customerSupport']
  }),
  getters: {
    dynamicFooterSections(state) {
      const authStore = useAuthStore()
      const userStore = useUserStore()
      const isLoggedIn = authStore.isLoggedIn
      const userType = userStore.userType

      const withoutUser = {
        baseApp: state.baseApp,
        policy: state.policy,
        customerSupport: state.customerSupport
      }
      if (!isLoggedIn) {
        return withoutUser
      }

      let dynamicServicesOptions = JSON.parse(JSON.stringify(state.services))
      const servicesByLoggedUserType =
        state.visibilityByUserType[userType] || state.visibilityByUserType['noUser']

      // Configurar dinámicamente el routeName de la primera opción
      if (dynamicServicesOptions.options.length > 0) {
        dynamicServicesOptions.options[0].routeName = userStore.routeToDasboardByUserType
      }

      if (servicesByLoggedUserType.includes('all')) {
        dynamicServicesOptions.options = dynamicServicesOptions.options.filter(
          (service) => service.key !== 'signUpProspect' && service.key !== 'login'
        )
        return {
          baseApp: state.baseApp,
          services: dynamicServicesOptions,
          policy: state.policy,
          customerSupport: state.customerSupport
        }
      }

      dynamicServicesOptions.options = dynamicServicesOptions.options.filter((service) =>
        servicesByLoggedUserType.includes(service.key)
      )
      return {
        baseApp: state.baseApp,
        services: dynamicServicesOptions,
        policy: state.policy,
        customerSupport: state.customerSupport
      }
    },
    sectionOrder(state) {
      const sections = Object.keys(this.dynamicFooterSections)
      console.log(state.defaultSectionOrder)
      return state.defaultSectionOrder.filter((section) => sections.includes(section))
    }
  },
  actions: {
    setFooterConfig(config) {
      this.baseApp = config.baseApp || {}
      this.services = config.services || {}
      this.customerSupport = config.customerSupport || {}
      this.policy = config.policy || {}
      this.socialNetworks = config.socialNetworks || []
      this.copyright = config.copyright || 'ACE & KBA'
      this.visibilityByUserType = config.visibilityByUserType || {}
      this.defaultSectionOrder = config.defaultSectionOrder || [
        'baseApp',
        'services',
        'policy',
        'customerSupport'
      ]
    }
  },
  persist: true
})
